export const CLUSTERS_ENDPOINT: string = "clusters";
export const HOSTS_ENDPOINT: string = "hosts";
export const NODES_ENDPOINT: string = "nodes";
export const JOBS_ENDPOINT: string = "jobs";
